
import { createStore , applyMiddleware,compose } from "redux";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web and AsyncStorage for react-native
import thunk from 'redux-thunk';
import rootReducer from '../reducers'

// const initialState ={};
// const middleware = [thunk];

const persistConfig = {
  key: 'root',
  storage,
  whitelist:['user','clientById','parametersListByParaType','orderTimer', 'posStorage']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default () => {
  let store = createStore(
    persistedReducer,
    composeEnhancers(
      applyMiddleware(thunk),
      ),
      // initialState,
    // applyMiddleware(...middleware),
)
  let persistor = persistStore(store)
  return { store, persistor }
}